export function hexToDecimal(hex: string) {
  return BigInt(hex).toString();
}
